<div class="py-px-16 px-px-32">
  <div class="d-flex justify-content-between">
    <div class="fs-20 fw-7">{{ data ? 'Modifier un gestionnaire' : 'Ajouter un gestionnaire' }}</div>
    <div>
      <svg-icon src="assets/icons/close.svg" class="cursor-pointer" (click)="dialogRef.close()"></svg-icon>
    </div>
  </div>
  <div  [formGroup]="form">
    <app-custom-input
      [parentForm]="form" controlName="mail"
      [errorMessage]="(this.form.get('mail')?.errors?.['email']) ? 'Veuillez entrer un email valide.' : ''"
      label="Email" [required]="true" innerClass="mt-px-16"></app-custom-input>


    <div class="row mt-px-16">
      <div class="col-3">
        <mat-label >Title <span class="required">*</span></mat-label>
        <div  class="dropdown position-relative" >
          <mat-select formControlName="civility">
            @for (item of civilityOptions; track item) {
              <mat-option [value]="item.value">{{item.label}}</mat-option>
            }
          </mat-select>
        </div>
      </div>
      <div class="col-4">
        <app-custom-input label="Nom" [parentForm]="form" controlName="firstName"
                          [required]="true"></app-custom-input>
      </div>
      <div class="col-5 ">
        <app-custom-input label="Prénom" [parentForm]="form" controlName="lastName"
                          [required]="true"></app-custom-input>
      </div>
    </div>

      <div class="d-flex w-100 mt-px-16">
        <app-custom-dragdrop-image text1=""
                                   [url]="images"
                                   innerClass="rounded border border-1 p-4 me-2"
                                   [singleImage]="true" text2="" width="146" height="146"
                                   [smallInput]="true" text3="Ajouter une photo de profil"
                                   icon="/assets/icons/camera.svg"
                                   (sendImage)="getImage($event)"
                                   [isDeletble]="true">
        </app-custom-dragdrop-image>
        <div class="d-flex flex-column mt-2 w-100 ml-px-16">
          <mat-label >Téléphone <span class="required">*</span></mat-label>
          <ngx-intl-tel-input
            [cssClass]="'custom'"
            [preferredCountries]="[CountryISO.France, CountryISO.France]"
            [enableAutoCountrySelect]="false"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="CountryISO.France"
            [maxLength]="phoneMaxLength"
            [phoneValidation]="true"
            [inputId]="'my-input-id'"
            formControlName="numTel"
            [(ngModel)]="phoneNumber"
            (ngModelChange)="onInputChange($event)"
          ></ngx-intl-tel-input>
          <div *ngIf="form.get('numTel')?.touched && form.get('numTel')?.invalid" class="required">
            Veuillez saisir un numéro valide.
          </div>

                <div class="w-100 mt-px-16">
                  <app-custom-input label="Fonction" [required]="true"
                  [parentForm]="form" controlName="fonction"
                  ></app-custom-input>
                </div>

<!--            <div class="d-flex flex-column mt-px-14 w-100 ">-->
<!--              <mat-label >Fonction <span class="required">*</span></mat-label>-->
<!--              <mat-form-field  appearance="outline">-->
<!--                <mat-select >-->
<!--                  @for (item of fonctionOptions; track item) {-->
<!--                    <mat-option [value]="item.value">{{item.label}}</mat-option>-->
<!--                  }-->
<!--                </mat-select>-->
<!--              </mat-form-field>-->
<!--            </div>-->
        </div>
      </div>

  </div>
  <mat-dialog-actions align="end" class="mt-px-24">
    <app-button (handleClick)="dialogRef.close()" [stroked]="true" text="Annuler"></app-button>
    <app-button (handleClick)="addContact()"
                [loading]="loading"
                [disabled]="form.invalid || loading"
                innerClass="ml-px-8"
                [text]=" data ? 'Confirmer les changements': 'Ajouter cette personne'"></app-button>
  </mat-dialog-actions>
</div>
